import { GraduationCap, CalendarCheck } from 'lucide-react';
import { useLang } from '../../i18n/LanguageContext';
import { BookNowButton } from './BookNowButton';

export const StudentPromo = () => {
  const { t } = useLang();
  return (
    <section className="py-14 lg:py-16">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="relative overflow-hidden border border-gold/40 bg-gradient-to-r from-ink via-surface to-ink px-6 py-10 lg:px-12 lg:py-12">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
            <div className="flex items-start gap-5">
              <div className="hidden sm:grid place-items-center w-14 h-14 shrink-0 bg-gold/10 border border-gold/30 text-gold">
                <GraduationCap size={26} />
              </div>
              <div>
                <span className="inline-block text-xs tracking-[0.3em] uppercase text-gold mb-2" data-testid="promo-badge">
                  {t.promo.badge}
                </span>
                <h3 className="font-serif text-2xl lg:text-3xl text-white leading-tight">
                  {t.promo.title} <span className="text-gold">— {t.promo.price}</span>
                </h3>
                <p className="text-sm text-white/60 mt-1">{t.promo.days}</p>
              </div>
            </div>
            <BookNowButton
              testId="promo-book-now-button"
              className="inline-flex items-center gap-2 bg-gold hover:bg-gold-dark text-ink font-bold uppercase tracking-widest px-8 py-4 transition-colors text-sm shrink-0"
            >
              <CalendarCheck size={18} /> {t.promo.book}
            </BookNowButton>
          </div>
        </div>
      </div>
    </section>
  );
};
